import {
  Badge,
  Card,
  CardMedia,
  Dialog,
  Divider,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { AddRounded, MoreHoriz, VisibilityRounded } from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import { updateSlogan } from '@webapps/business';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import CropEasy from 'components/crop/CropEasy';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import theme from '../theme';

const {
  colors: { background },
} = theme;

const ProfilName = ({
  city,
  coverImage,
  cp,
  name,
  profileImage,
  refetch,
  slogan,
  // verified,
  website,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();
  const history = useHistory();
  const { idUser } = useAuth();

  const {
    error,
    isLoading,
    isSuccess,
    mutateAsync: mutateUpdateSlogan,
  } = useMutation(updateSlogan);

  const handleViewVitrine = () => {
    history.push(ROUTES_PATH.MY_VITRINE_SCHOOL);
  };

  const [openCrop, setOpenCrop] = useState(false);
  const [openCropProfile, setOpenCropProfile] = useState(false);
  const [anchorVitrine, setanchorVitrine] = useState(null);

  const openCandid = Boolean(anchorVitrine);

  const [characterCount, setCharacterCount] = useState(0);
  const [sloganData, setSloganData] = useState('');
  const textAreaRef = useRef(null);

  const handleCharacterChange = (event) => {
    const newCharacterCount = event.target.value.length;
    const text = event.target.value;
    if (newCharacterCount <= 120) {
      setSloganData(text);
      setCharacterCount(newCharacterCount);
    }
  };

  const handleSloganSubmit = () => {
    mutateUpdateSlogan({
      data: sloganData,
      id: idUser,
    });
  };

  const handleClick = (event) => {
    setanchorVitrine(event.currentTarget);
  };

  const handleClose = () => {
    setanchorVitrine(null);
  };

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: "Erreur lors de l'édition du slogan",
      });
    }
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Slogan modifié avec succès',
      });
    }
  }, [error, isSuccess]);

  useEffect(() => {
    if (slogan) {
      setSloganData(slogan);
      setCharacterCount(slogan.length);
    }
  }, [slogan]);

  return (
    <div className={classes.container}>
      <Grid container>
        <Grid item xs>
          <Paper className={cx(classes.title)} elevation={0}>
              <Card
                className={css({
                  position: 'relative',
                  borderTopRightRadius: 10,
                  borderTopLeftRadius: 10,
                })}
                classes={{
                  root: css({
                    overflow: 'visible',
                  }),
                }}
                elevation={0}
              >            
              {coverImage ? (
                <CardMedia
                  component="img"
                  alt="cover image"
                  image={coverImage}
                  style={{
                    borderTopRightRadius: 10,
                    borderTopLeftRadius: 10,
                  }}
                /> ) : (
                  <div
                  className={cx(
                    classes.title,
                    css({
                      background: '#0060F9',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                    })
                  )}
                >
                </div>
                )}
                <Badge
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  badgeContent={
                    <IconButton
                      className={css({
                        background: '#F3F7FF',
                        border: '1px solid #C0D9FF',
                        width: '24px',
                        height: '24px',
                        '&:hover': {
                          backgroundColor: '#F3F7FF',
                        },
                      })}
                      onClick={() => setOpenCropProfile(true)}
                      size="small"
                    >
                      <AddRounded
                        style={{ color: '#5A6DA1', fontSize: '15.0px' }}
                      />
                    </IconButton>
                  }
                  overlap="circular"
                  className={css({
                    position: 'absolute',
                    bottom: -40,
                    left: 30,
                  })}
                >
                  {profileImage ? (
                    <Avatar className={classes.avatar} src={profileImage} />
                  ) : (
                    <Avatar className={classes.avatar}>
                      {name?.substr(0, 1)}
                    </Avatar>
                  )}
                </Badge>
              </Card>
            <div>
              <IconButton
                className={css({
                  position: 'absolute',
                  top: 15,
                  right: 15,
                  background: '#F3F7FF',
                  border: '1px solid #C0D9FF',
                  width: '24px',
                  height: '24px',
                  '&:hover': {
                    backgroundColor: '#F3F7FF',
                  },
                })}
                onClick={() => setOpenCrop(true)}
                size="small"
              >
                <AddRounded style={{ color: '#5A6DA1', fontSize: '15.0px' }} />
              </IconButton>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <div className={classes.divDescription}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-evenly',
          }}
        >
          <div
            className={css({
              display: 'flex',
              marginTop: 20,
              flexDirection: 'column',
              justifyContent: 'center',
              fontFamily: 'Montserrat',
            })}
          >
            <div className={cx(classes.name, global.title)}>
              {name}
              <div
                className={css({
                  marginLeft: spacing(1),
                })}
              >
                <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
              </div>
            </div>
          </div>
        </div>
        <div
          className={css({
            marginTop: '20px',
            display: 'flex',
            alignItems: 'flex-start',
          })}
        >
          <div className={classes.iconsDesktop}>
            {/* {website && (
              <Button
                className={css({
                  borderRadius: 20,
                  whiteSpace: 'nowrap',
                  minWidth: 'auto',
                  borderRadius: '10.00px'
                })}
                color="primary"
                fullWidth
                href={
                  website.includes('http') ? `${website}` : `http://${website}`
                }
                target="_blank"
                variant="contained"
              >
                Voir le site web
              </Button>
            )} */}
            <Button
              className={css({
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                padding: '0px 20px 0px 20px',
              })}
              fullWidth
              onClick={handleViewVitrine}
              variant="outlined"
              startIcon={<VisibilityRounded style={{ fontSize: '24px' }} />}
            >
              Prévisualiser ma vitrine
            </Button>
          </div>
        </div>
      </div>
      <div style={{ width: '100%' }}>
        <Divider />
      </div>
      <div className={classes.divDescription}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <p style={{ margin: 0 }} className={global.title}>
            Slogan
          </p>
          <p style={{ margin: '8px 0px 0px 0px' }}>
            Élaborez un slogan qui caractérise votre établissement
          </p>
          <div
            style={{
              margin: '20px 0px 0px 0px',
              position: 'relative',
              width: '100%',
            }}
          >
            <TextareaAutosize
              className={classes.sloganTextArea}
              maxRows={3}
              value={sloganData}
              onBlur={handleSloganSubmit}
              onChange={handleCharacterChange}
              ref={textAreaRef}
            />
            <p
              className={css({
                position: 'absolute',
                bottom: 10,
                right: 15,
                margin: 0,
                textAlign: 'right',
                color: '#5D75A8',
                padding: '5px 10px',
                '@media (max-width:1020px)': { right: 15 },
                '@media (max-width:767px)': { right: 15 },
              })}
            >
              Caractères : {characterCount}/120
            </p>
          </div>
        </div>
      </div>
      <Dialog
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 45, 117, 0.6)',
          },
        }}
        classes={{
          paperScrollPaper: css({
            width: '100%',
            maxWidth: 1000,
            borderRadius: 10,
            '@media screen and (max-width: 768px)': {
              margin: '10px',
            },
          }),
        }}
        onClose={() => setOpenCrop(false)}
        open={openCrop}
      >
        <CropEasy
          {...{
            photoURL: coverImage,
            setOpenCrop,
            type: 'cover',
            refresh: refetch,
          }}
        />
      </Dialog>
      <Dialog
        classes={{
          paperScrollPaper: css({
            '@media screen and (max-width: 768px)': {
              margin: '10px',
              height: '60vh',
            },
            width: '100%',
          }),
        }}
        onClose={() => setOpenCropProfile(false)}
        open={openCropProfile}
      >
        <CropEasy
          {...{
            photoURL: profileImage,
            setOpenCrop: setOpenCropProfile,
            type: 'profile',
            refresh: refetch,
          }}
        />
      </Dialog>
    </div>
  );
};

const styles = ({ spacing }) => ({
  btnSave: {
    marginTop: spacing(2),
    borderRadius: '10.0px',
    width: '10vw',
    '@media screen and (max-width:1020px)': { width: '20vw' },
    '@media screen and (max-width:767px)': { width: '30vw' },
  },
  container: {
    position: 'sticky',
    top: 0,
    height: 'fit-content',
    borderRadius: 20,
    background,
    '@media only screen and (max-width:768px)': {
      marginTop: spacing(3),
      paddingTop: 0,
    },
  },
  containerInfo: {
    padding: spacing(3),
  },
  avatar: {
    height: 80,
    width: 80,
    background: '#5A6DA1',
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    marginTop: '10px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  sloganTextArea: {
    border: '1px solid #C0D9FF',
    width: '100%',
    resize: 'none',
    minHeight: '128px',
    borderRadius: '5px',
    backgroundColor: '#F3F7FF',
    color: '#152652',
    fontFamily: 'Roboto',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    padding: spacing(2.5),
    '&:focus': {
      outline: 'none',
    },
  },
  divDescription: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    '@media only screen and (min-width:769px) and (max-width:1060px)': {
      flexDirection: 'column',
      alignItems: 'start',
    },
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  iconsDesktop: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'flex-start',
    '@media only screen and (min-width:769px) and (max-width:1060px)': {
      marginTop: spacing(2),
    },
  },
  iconsMobile: {
    '@media screen and (min-width: 769px)': {
      display: 'none',
    },
  },
  title: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    position: 'relative',
    
  },
});

ProfilName.propTypes = {
  city: PropTypes.string,
  cp: PropTypes.string,
  name: PropTypes.string,
  coverImage: PropTypes.string,
  profileImage: PropTypes.string,
  verified: PropTypes.bool,
  website: PropTypes.string,
  refetch: PropTypes.func,
};

export default ProfilName;
